module.exports = __webpack_public_path__ + "static/bossypants-de00e635d5baf7fe0a6a811f30d22940.jpg";